import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemText,
  CssBaseline,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
} from "@mui/material";
import AddStudent from "./AddStudent";
import AllStudents from "./AllStudents";
import AddTeacher from "./AddTeacher";
import TeacherDetails from "./TeacherDetails";
import FeesManagement from "./FeesManagement";
import LogoutIcon from "@mui/icons-material/Logout";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import DashboardGraph from "./Dashboard"; // Assuming DashboardGraph is your dashboard chart
import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import { CircularProgress } from "@mui/material"; // Import CircularProgress
import axios from "axios";
import Profile from "../../componests/Profile";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import BatteryStatus from './BatteryStatus'
import AttendanceTracking from "./AttendanceTracking";
import {url} from './../../BaseUrl'
const Dashboard = () => {
  const [view, setView] = useState("HOME");
  const [anchorEl, setAnchorEl] = useState(null); // For handling the profile menu
  const navigate = useNavigate();

  const user = {
    name: "Admin",
    avatar: "https://via.placeholder.com/40", // Placeholder avatar URL
  };

  // Function to handle opening the profile menu
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Function to close the profile menu
  const handleMenuClose = () => {
    setAnchorEl(null);
    setView("profile");
  };

  // Function to handle logout
  const handleLogout = () => {
    sessionStorage.clear("token");
    navigate("/");
  };

  // Query for fetching student data
  const { isLoading, error, data } = useQuery("fetchAllStudents", async () => {
    const token = sessionStorage.getItem("token");

    const response = await axios.get(
      `${url}/api/auth/fetchUser`, // Ensure the correct endpoint
      {
        headers: {
          Authorization: `Bearer ${token}`, // Send token in the Authorization header
          "Content-Type": "application/json",
        },
      }
    );

    return response.data?.organization; // Return the fetched data
  });
  // Render different views based on state
  const renderView = () => {
    switch (view) {
      case "addStudent":
        return <AddStudent />;
      case "allStudents":
        return <AllStudents data={data} />; // Pass fetched data to AllStudents component
      case "addTeacher":
        return <AddTeacher />;
      case "allTeachers":
        return <TeacherDetails data={data} />;
      case "feesManagement":
        return <FeesManagement />;
      case "dashboard":
        return <DashboardGraph dataGraph={data} />;
      case "SIDashboard":
        return <BatteryStatus/>;
      case "Attendance" :
      return <AttendanceTracking attendance={data.attendance}/>;
      default:
        return <Profile adminData={data} />;
    }
  };

  // Display loading state
  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh", // Full height to center the loader
        }}
      >
        <CircularProgress color="primary" />
        <Typography variant="h6" sx={{ marginTop: 2 }}>
          Loading...
        </Typography>
      </Box>
    );
  }

  // Display error message if there's an error
  if (error) {
    return (
      <Typography variant="h6">
        An error has occurred: {error.message}
      </Typography>
    );
  }

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      {/* AppBar with Organization Name, Address, and Profile Menu */}
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: "#002B5B", // Set the AppBar background color
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          {/* Organization Name and Address */}
          <Box>
            <Typography variant="h6" noWrap component="div">
              {data.organizationName}
            </Typography>
            <Typography variant="body2" noWrap component="div">
              {data.address.street} {data.address.city} {data.address.state}{" "}
              {data.address.country}
            </Typography>
          </Box>

          {/* Profile Avatar and Logout */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton onClick={handleMenuClick} color="inherit">
              <Avatar>{data.organizationName.split("")[0]}</Avatar>
            </IconButton>

            {/* Profile Menu */}
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={handleMenuClose}>
                <AccountCircleIcon sx={{ marginRight: 1 }} />
                Profile
              </MenuItem>
              <MenuItem onClick={handleLogout}>
                <LogoutIcon sx={{ marginRight: 1 }} />
                Logout
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Drawer for Sidebar */}
      <Drawer
        variant="permanent"
        sx={{
          width: 240,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: { width: 240, boxSizing: "border-box" },
        }}
      >
        <Toolbar />
        <List>
          <ListItem button onClick={() => setView("dashboard")}>
            <DashboardIcon />
            <ListItemText
              primary="Dashboard"
              primaryTypographyProps={{
                sx: { color: "#002B5B", fontWeight: "bold" }, // Apply color and bold to text
              }}
            />
          </ListItem>
          <ListItem button onClick={() => setView("addStudent")}>
            <AddCircleIcon />
            <ListItemText
              primary="Add Student"
              primaryTypographyProps={{
                sx: { color: "#002B5B", fontWeight: "bold" }, // Apply color and bold to text
              }}
            />
          </ListItem>

          <ListItem button onClick={() => setView("allStudents")}>
          <AddCircleIcon />
            <ListItemText
              primary="All Students"
              primaryTypographyProps={{
                sx: { color: "#002B5B", fontWeight: "bold" },
              }}
            />
          </ListItem>
          <ListItem button onClick={() => setView("addTeacher")}>
            <AddCircleIcon />
            <ListItemText
              primary="Add Teacher"
              primaryTypographyProps={{
                sx: { color: "#002B5B", fontWeight: "bold" },
              }}
            />
          </ListItem>
          <ListItem button onClick={() => setView("allTeachers")}>
          <AddCircleIcon />
            <ListItemText
              primary="All Teachers"
              primaryTypographyProps={{
                sx: { color: "#002B5B", fontWeight: "bold" },
              }}
            />
          </ListItem>
          <ListItem button onClick={() => setView("SIDashboard")}>
          <AddCircleIcon />
            <ListItemText
              primary="System status"
              primaryTypographyProps={{
                sx: { color: "#002B5B", fontWeight: "bold" },
              }}
            />
          </ListItem>

          <ListItem button onClick={() => setView("feesManagement")}>
          <AddCircleIcon />
            <ListItemText
              primary="Fees Management"
              primaryTypographyProps={{
                sx: { color: "#002B5B", fontWeight: "bold" },
              }}
            />
          </ListItem>
          
          <ListItem button onClick={() => setView("Attendance")}>
          <AddCircleIcon />
            <ListItemText
              primary="Attendance Tracking"
              primaryTypographyProps={{
                sx: { color: "#002B5B", fontWeight: "bold" },
              }}
            />
          </ListItem>
          <ListItem button onClick={() => setView("feesManagement")}>
          <AddCircleIcon />
            <ListItemText
              primary="Inventory Management"
              primaryTypographyProps={{
                sx: { color: "#002B5B", fontWeight: "bold" },
              }}
            />
          </ListItem>
        </List>
      </Drawer>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "background.default",
          p: 3,
        }}
      >
        <Toolbar />
        {renderView()}
      </Box>
    </Box>
  );
};

export default Dashboard;

// - Student & Teacher Management: A system to manage student and teacher profiles, classes, and schedules.
// - Attendance Tracking: A feature to record and monitor student attendance.
// - Grade Reporting: A system to input and track student grades.
// - Bus Tracking: A real-time tracking system for school buses.
// - Fee Management: A module to manage and track school fees.
// - Payroll Management: A system to manage teacher and staff salaries.

